
define('template!portalUserCreateTpl', ['lodash'], function(_) {return function(obj) {
obj || (obj = {});
var __t, __p = '', __e = _.escape, __j = Array.prototype.join;
function print() { __p += __j.call(arguments, '') }
with (obj) {
__p += '<div class="portal-user-create">\n  <div class="form-group">\n    <label for="portal-user-email">' +
((__t = ( _.i18n('common.email', null, 'Email') )) == null ? '' : __t) +
' *</label>\n    <input id="portal-user-email" type="email" class="form-control js-info-input" data-field-name="email" value="' +
((__t = ( email )) == null ? '' : __t) +
'"/>\n  </div>\n  <div class="row">\n    <div class="col-xs-6 form-group">\n      <label for="portal-user-first-name">' +
((__t = ( _.i18n('common.first.name', null, 'First name') )) == null ? '' : __t) +
'</label>\n      <input id="portal-user-first-name" type="text" class="form-control js-info-input" data-field-name="firstName" value="' +
((__t = ( firstName )) == null ? '' : __t) +
'"/>\n    </div>\n    <div class="col-xs-6 form-group">\n      <label for="portal-user-last-name">' +
((__t = ( _.i18n('common.last.name', null, 'Last name') )) == null ? '' : __t) +
'</label>\n      <input id="portal-user-last-name" type="text" class="form-control js-info-input" data-field-name="lastName" value="' +
((__t = ( lastName )) == null ? '' : __t) +
'"/>\n    </div>\n  </div>\n  <div class="form-group">\n    <label for="portal-user-locale">' +
((__t = ( _.i18n('portalUsers.language', null, 'Portal language') )) == null ? '' : __t) +
'</label>\n    <select id="portal-user-locale" class="form-control js-info-input" data-field-name="locale">\n      ';
 _.each(locales, function (code) { ;
__p += '\n        <option value="' +
((__t = ( code )) == null ? '' : __t) +
'" ' +
((__t = ( code === locale ? 'selected' : '' )) == null ? '' : __t) +
'>' +
((__t = ( code.toUpperCase() )) == null ? '' : __t) +
'</option>\n      ';
 }); ;
__p += '\n    </select>\n  </div>\n\n  <p class="hint">' +
((__t = ( _.i18n('portalUsers.createHint', null,
    'Creating the account produces an invitation link valid for 72 hours. Send it to the supplier yourself — it is not emailed automatically.') )) == null ? '' : __t) +
'</p>\n\n  <div class="error-message"></div>\n\n  <div class="popup-footer">\n    <button type="button" class="btn js-cancel-popup">' +
((__t = ( _.i18n('common.cancel', null, 'Cancel') )) == null ? '' : __t) +
'</button>\n    <button type="button" class="btn btn-primary js-confirm">' +
((__t = ( _.i18n('portalUsers.create', null, 'Create account') )) == null ? '' : __t) +
'</button>\n  </div>\n</div>\n';

}
return __p
};});

